import React from 'react'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import TrendingDestinationsTile from 'home/components/TrendingDestinations/TrendingDestinationTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'

export type TrendingDestination = {
  name: string;
  imageId: string;
  url: string;
  destinationId?: string;
}

const GridContainer = styled(FullWidthCarouselWithAnalytics)`
  > div {
    grid-template-rows: 1fr 1fr 1fr;

    ${mediaQueryUp.tablet} {
      grid-template-rows: unset;
    }
  }
`

const trendingDestinations = [
  { name: 'Italy', imageId: '7q9jb0gdhplm14173k', url: '/italy.p1' },
  { name: 'Austria', imageId: 'thouj6036ss19a48hd9', url: '/austria.p1' },
  { name: 'Greece', imageId: '53m8tnzccxq53w0so4p', url: '/greece.p1' },
  { name: 'London', imageId: 'wpyvdwvy3gvho40q82nc', url: '/london.p1' },
  { name: 'Indonesia', imageId: 'n0y2fxopviu5ms9nyxl', url: '/bali.p1' },
  { name: 'Cruises', imageId: '02pn9b84o2dv7qgboad', url: '/cruises' },
  { name: 'Maldives', imageId: 'vl6c6uixvdt27kksknwd', url: '/maldives.p1' },
  { name: 'Dubai', imageId: '2anzx7hi4om06pme02', url: '/dubai.p1' },
  { name: 'South Africa', imageId: 'boy0r8z1i3qdx8uroqss', url: '/south-africa.p1' },
  { name: 'Thailand', imageId: '9v0qqs5xfbdjy07nb4b', url: '/thailand.p1' },
  { name: 'New York', imageId: 'icctwlrx3bxwjikdf5hh', url: '/new-york.p1' },
  { name: 'Fiji', imageId: 'pjcb9n8hx187hl7hiu7', url: '/fiji.p1' },
  { name: 'Australia', imageId: 'dx7vgugcasihlmd9h1e', url: '/australia.p1' },
]

function LETVDestinations() {
  return (
    <Group direction="vertical" gap={32}>
      <LayoutContainer size="lg">
        <Heading variant="heading3">
          Explore featured escapes from <i>Luxury Escapes TV</i> Season 6
        </Heading>
      </LayoutContainer>

      <GridContainer snap="start" itemsPerArrow={4}>
        {trendingDestinations.map((trendingDestination, index) => (
          <TrendingDestinationsTile
              key={trendingDestination.name}
              trendingDestination={trendingDestination}
              fetchingMaxSavings={false}
              index={index}
            />

        ))}
      </GridContainer>
    </Group>
  )
}

export default LETVDestinations
